import { CachedSegmentsProgress } from '../../../fragment-editor/components/CachedSegmentsProgress';
import { useCacheSegmentsAudio } from './useCacheSegmentsAudio';

export function SegmentsAudioCache() {
  const { progress } = useCacheSegmentsAudio();

  return (
    <div className="my-2">
      <CachedSegmentsProgress progress={progress} />
    </div>
  );
}
